module.exports = __webpack_public_path__ + "img/in-use-daniela-mazel@2x.abc6eb03.jpg";